module.exports = function(cb) {
	require.ensure([], function(require) {
		cb(require("!!../../../node_modules/babel-loader/lib/index.js!../../../node_modules/jsxstyle-webpack-plugin/lib/loader.js??ref--0-1!../../../node_modules/eslint-loader/index.js??ref--0-2!./index.js"));
	});
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/bundle-loader?lazy!./components/Battles/Season4/index.js
// module id = 274
// module chunks = 95